import { Component, Input, OnInit, inject, input, output } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { ReferenceMeasurementItemLengthComponent } from "@components/reference-measurement-item-length/reference-measurement-item-length.component";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanSidesheetExtent } from "@domain/project/floorplan/floorplan-sidesheet-extent";
import { Pipeline } from "@domain/project/floorplan/wiring/pipeline";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";

@Component({
  selector: "app-pipeline-notes",
  templateUrl: "./pipeline-notes.component.html",
  styleUrl: "./pipeline-notes.component.scss",
  imports: [UiKitModule, ReactiveFormsModule, FloorplanItemDetailsComponent, ReferenceMeasurementItemLengthComponent],
  standalone: true,
})
export class PipelineNotesComponent implements OnInit {
  private formBuilder = inject(FormBuilder);

  @Input({ required: true }) set floorplanItem(item: FloorplanItem) {
    this.pipeline = item as Pipeline;
  }
  readonly extent = input.required<FloorplanSidesheetExtent>();
  readonly toggleExtendedButtonClicked = output<void>();

  protected pipelineForm!: FormGroup;
  protected pipeline!: Pipeline;

  ngOnInit() {
    this.initForm();
  }

  private update(): void {
    this.pipeline.updateMetadata(
      this.pipelineForm.value.diameter,
      this.pipelineForm.value.medium,
      this.pipelineForm.value.temperature,
      this.pipelineForm.value.material,
      this.pipelineForm.value.name,
    );
    this.pipeline.notes = this.pipelineForm.value.notes;
  }

  private initForm() {
    this.pipelineForm = this.formBuilder.group({
      name: [this.pipeline.name],
      diameter: [this.pipeline.diameter],
      medium: [this.pipeline.medium],
      temperature: [this.pipeline.temperature],
      material: [this.pipeline.material],
    });

    this.pipelineForm.valueChanges.subscribe(() => {
      if (!this.pipelineForm.valid || this.pipelineForm.pristine) return;
      this.update();
    });
  }
}
